import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <span className="font-heading text-2xl text-primary-400">KY</span>
              <p className="mt-3 text-sm text-background-300 leading-relaxed">
                www.ky.app 是KY应用官方指定地址，提供最新版本极速下载与安全安装服务，致力于为全球用户提供稳定流畅的移动应用体验。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/category/tutorial" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">教程攻略</Link>
                </li>
                <li>
                  <Link to="/category/news" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">更新动态</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">帮助支持</h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">安装教程</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">账号注册</a>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>support@ky.app</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-customer-service-2-line text-primary-400"></i>
                  <span>在线客服 7×24小时</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-shield-check-line text-primary-400"></i>
                  <span>隐私安全保障</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-12 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} KY App 官方网站. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">Cookie 政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}